/**
 * Created by supunm on 2/1/19.
 */


(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name languageDiscrepancy.service:languageDiscrepancyService
   *
   * @description
   *
   */
  angular
    .module('maleFemaleDiscrepancy')
    .service('maleFemaleDiscrepancyService', maleFemaleDiscrepancyService);

  function maleFemaleDiscrepancyService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchMaleFemaleDiscrepancy = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchMaleFemaleDiscrepancy(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptSearchRequset(param) {
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        noOfMales: param.noOfMales
      };
      return actualSearchParam;
    }

  }
}());
